import { KYMW1901Model } from '../kymw1901.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

@Injectable()
export class GetMembersVoiceOutputNumService extends PlessJsonResponderSub<any> {

  orderCode: string;

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1901Model}
   * @memberof GetMembersVoiceOutputNumService
   */
  private model: KYMW1901Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetMembersVoiceOutputNumService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMembersVoiceOutputNumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {Function} [successFunc=null]
   * @memberof GetMembersVoiceOutputNumService
   */
  execute(model: any, orderCode: string, successFunc: Function = null): void {
    this.successFunc = successFunc;
    this.model = model;
    this.orderCode = orderCode;
    this.send('getMembersVoiceOutputNum', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMembersVoiceOutputNumService
   */
  success(data: any): void {
    if (data !== null) {
      // 後続処理を実行
      this.successFunc(data);
    }
  }
}
